import React, { useEffect, useState } from "react";
import { Footer, Header } from "../basicComponent/Basic";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useMutation } from "react-query";
import { url, localUrl } from "../../BaseUrl";
const StudentLogin = () => {
  const [schoolId, setSchoolId] = useState("");
  const [studentEmail, setstudentEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLogin, setIsLogin] = useState(false);
  const [Institute,setInstitute]=useState()
  const navigate = useNavigate();

  // Define the login mutation
  const mutation = useMutation(
    async (loginData) => {
      const response = await axios.post(
        `${url}/api/auth/studentlogin`,
        loginData
      );
      // Update the endpoint if necessary
      return response.data;
    },
    {
      onSuccess: (data) => {
        
        // Handle success (e.g., store the token and navigate to student dashboard)
        setSuccessMessage("Login successful!");
        sessionStorage.setItem("studentToken", data);
        if (data) {
          setIsLogin(true);
          navigate("/manageedu/dashboard/student", { state: true }); // Redirect to student dashboard
        }
        else
        {
          navigate("/", { state: true });
        }
      },
      onError: (error) => {
        // Handle errors (e.g., display an error message)
        setErrorMessage("Login failed. Please check your credentials.");
        setIsLogin(false);
      },
    }
  );


  const handleLogin = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    // Basic validation
    if (!schoolId || !studentEmail || !password) {
      setErrorMessage("All fields are required!");
      return;
    }

    const loginData = { schoolId, studentEmail, password };

    // Trigger the mutation
    mutation.mutate(loginData);
  };
   const getInstituteAll= async ()=>{
    const institute= await axios.get(`${url}/api/auth/getAllInstitute`)
    setInstitute(institute);

   }
  useEffect(()=>{
    getInstituteAll();
  },[])
  return (
    <div>
      <Header LoggedIn={isLogin} />
      <div className="login-container">
        <h2>Student Login</h2>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}

        {/* School Selection Dropdown */}
        <div className="form-group">
          <select
            value={schoolId}
            onChange={(e) => setSchoolId(e.target.value)}
            className={`form-input ${schoolId ? "" : "input-error"}`}
          >
            <option value="">Select Your School</option>
            {/* Hardcoded school options */}

            {Institute?.data?.organizations?.map((item,index)=>{
              return <option key={index} value={item.id}>{item.organizationName}</option>
            })}
          </select>
        </div>

        <div className="form-group">
          <input
            type="email"
            placeholder="Student Email"
            value={studentEmail}
            onChange={(e) => setstudentEmail(e.target.value)}
            className={`form-input ${studentEmail ? "" : "input-error"}`}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={`form-input ${password ? "" : "input-error"}`}
          />
        </div>
        <button
          className="submit-btn"
          onClick={handleLogin}
          disabled={mutation.isLoading}
        >
          {mutation.isLoading ? "Logging in..." : "Login"}
        </button>
      </div>
      <Footer />
    </div>
  );
};

export default StudentLogin;
